import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncSpotifyToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncSpotifyToAppleMusic}
            sections={<PairSyncGuideContent sourceKey="spotify" destKey="appleMusic" />}
        />
    );
}
